
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api';

import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { sor } from 'src/types/sor';
import { sor_returndata } from 'src/types/sor_returndata';
import { BusyService } from '../_services/busy.service';


@Component({
  selector: 'app-statementofriskedit',
  templateUrl: './statementofriskedit.component.html',
  styleUrls: ['./statementofriskedit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StatementofriskeditComponent  implements OnInit {
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  SOR: sor;
  httpResponse: any;
  id: string;
  pageReady: boolean = true;

  sorNameValid: boolean = true;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  ShowOTP: boolean = false;

  // OTP related properties
  otpCode: string[] = ['', '', '', '', '', ''];

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private globalService: GlobalService, private busyService: BusyService) { 
    this.SOR = {
      id: null,
      sorid: null,
      name: "",
      venueid: this.VenueID,
      createddate: new Date(),
      startdate: new Date(),
      enddate: new Date(),
      text: "",
      disabled: false,  
      isactive: true,
      status: "SUBMITTED" // SUBMITTED, APPROVED, REJECTED
    }
  }

  submitOtpCode(){

    const enteredCode = this.getOtpValue();
    this.ShowOTP = false;
    const otpHeaders = new HttpHeaders().set('otp', enteredCode);
    this.SOR.startdate = new Date();
    if(this.id == "0")
    {
      this.http.post<sor>(bmxurl + "/StatementOfRisk", this.SOR, { headers: otpHeaders }).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.clearOtpInputs();

            this.messageService.add({severity:'success', summary:'Saved', detail:'Statement of Risk successfully updated'});
            this.router.navigateByUrl("/statementofrisk");
          }
          else
          {
            this.clearOtpInputs();
            this.messageService.add({severity:'error', summary:'Not Saved', detail:this.httpResponse.messages[0]});
          }
          }, error => {
            this.clearOtpInputs();
            
            this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
    }
    else
    {
      this.SOR.disabled = false;
      
      this.http.put<sor>(bmxurl + "/StatementOfRisk", this.SOR, { headers: otpHeaders }).subscribe(response => {
      this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.clearOtpInputs();

          this.messageService.add({severity:'success', summary:'Saved', detail:'Your Statement of Risk has been successfully uploaded for approval, this will be approved by a business owner and will go live on approval.'});
          this.router.navigateByUrl("/statementofrisk");
        }
        else
        {
          this.clearOtpInputs();
          this.messageService.add({severity:'error', summary:'Not Saved', detail:this.httpResponse.messages[0]});
        }
        }, error => {
          this.clearOtpInputs();

          this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
      })
    }
  }

  clearOtpInputs() {
    this.otpCode = ['', '', '', '', '', ''];
    const inputs = document.querySelectorAll('.otp-input');
    inputs.forEach(input => (input as HTMLInputElement).value = '');
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CLASSES", user)){
          this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "StatementOfRisk/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as sor_returndata)
              if (this.httpResponse.succeeded)
              {
                this.SOR = {
                  id: (this.httpResponse.data as sor).id,
                  sorid: (this.httpResponse.data as sor).sorid,
                  name: (this.httpResponse.data as sor).name,
                  createddate: new Date((this.httpResponse.data as sor).createddate),
                  startdate: new Date((this.httpResponse.data as sor).startdate),
                  enddate: new Date((this.httpResponse.data as sor).enddate),
                  text: (this.httpResponse.data as sor).text,
                  venueid: (this.httpResponse.data as sor).venueid,
                  disabled: (this.httpResponse.data as sor).disabled,
                  isactive: (this.httpResponse.data as sor).isactive,
                  status: (this.httpResponse.data as sor).status
                };
      
                this.pageReady = true;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting statement of risks'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting statement of risks, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }

  updateData()
  {
    if (this.DoValidCheck())
    {
      this.busyService.busy();
      let OPTRequest= {
        venueid: this.VenueID,
        module : "STATEMENTOFRISK"
      }

      this.http.post(bmxurl + "otp", OPTRequest).subscribe(response => {
        this.httpResponse = response
        if(this.httpResponse.succeeded)
        {
          this.ShowOTP = true;

          setTimeout(() => {
            const firstInput = document.querySelector('.otp-input') as HTMLInputElement; 
            if (firstInput) {
              firstInput.focus();
            }
          }, 0);

          this.busyService.idle();
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Error', detail:'Error while requesting OTP, error:' + this.httpResponse.messages[0]});
          this.busyService.idle();
        }
        }, error => {
          this.messageService.add({severity:'error', summary:'Error', detail:'Error while requesting OTP, error:' + error.messages[0]});
          this.busyService.idle();
      });
    }
  }

  DoValidCheck()
  {
    let AllValid = true;

    if(this.SOR.name == null || this.SOR.name == "")
    {
      AllValid = false;
      this.sorNameValid = false;
    }
    else
    {
      this.sorNameValid = true;
    }

    return AllValid;
  }

  returnToList()
  {
    this.router.navigateByUrl("/statementofrisk");
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    const value = input.value.toUpperCase();
    
    // Only allow alphanumeric characters
    if (!/^[A-Z0-9]$/.test(value) && value !== '') {
      input.value = '';
      this.otpCode[index] = '';
      return;
    }
    
    this.otpCode[index] = value;
    
    // Move to next input if current input is filled
    if (value && index < 5) {
      const inputs = document.querySelectorAll('.otp-input');
      if (inputs[index + 1]) {
        (inputs[index + 1] as HTMLInputElement).focus();
      }
    }
  }
  
  onOtpKeydown(event: any, index: number) {
    // Handle backspace
    if (event.key === 'Backspace' && !this.otpCode[index] && index > 0) {
      const inputs = document.querySelectorAll('.otp-input');
      if (inputs[index - 1]) {
        (inputs[index - 1] as HTMLInputElement).focus();
      }
    }
  }
  
  getOtpValue(): string {
    return this.otpCode.join('');
  }

  onOtpPaste(event: any, index: number) {
    event.preventDefault();
    
    // Get pasted text
    const pasteData = (event.clipboardData || (window as any).clipboardData).getData('text');
    
    // Remove any non-alphanumeric characters (including hyphens)
    const cleanedData = pasteData.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    
    // Only process if we have exactly 6 characters
    if (cleanedData.length === 6) {
      // Fill all OTP fields
      for (let i = 0; i < 6; i++) {
        this.otpCode[i] = cleanedData[i] || '';
      }
      
      // Focus the last input field
      setTimeout(() => {
        const inputs = document.querySelectorAll('.otp-input');
        if (inputs[5]) {
          (inputs[5] as HTMLInputElement).focus();
        }
      }, 10);
    } else if (cleanedData.length > 0) {
      // If less than 6 characters, fill from current position
      const remainingSlots = 6 - index;
      const charsToFill = Math.min(cleanedData.length, remainingSlots);
      
      for (let i = 0; i < charsToFill; i++) {
        this.otpCode[index + i] = cleanedData[i] || '';
      }
      
      // Focus the next empty field or last field
      setTimeout(() => {
        const nextIndex = Math.min(index + charsToFill, 5);
        const inputs = document.querySelectorAll('.otp-input');
        if (inputs[nextIndex]) {
          (inputs[nextIndex] as HTMLInputElement).focus();
        }
      }, 10);
    }
  }
}
